import { createContext, useContext } from 'react';
import { Property } from '@model';
import { Geometry } from '@model';
import { Lookups } from '@model';

export type PropertiesModel = {
  allAreasWithProperties: string[];
  culture: string;
  setCulture: (culture: string) => void;
  geometries: Geometry[];
  lookups?: Lookups;
  properties: Property[];
  refresh: () => void;
};

export const PropertiesContext = createContext<PropertiesModel>({
  allAreasWithProperties: [],
  culture: 'el',
  setCulture: () => {},
  geometries: [],
  properties: [],
  refresh: () => {},
});

export const useProperties = () => useContext(PropertiesContext);
